import React from 'react'
import './studentWorks.css'
import Menubar from '../home/menubar/Menubar'
import Address from '../home/footer/Address'
import {ms_works, dtp_works, c_works, tally_works, ve_works, html_works} from '../home/data.js'
import MarqueeSection from './MarqueeSection.jsx'
import ScrollToTopProgress from '../home/header/ScrollToTopProgress.jsx'
import Header from '../home/header/Header.jsx'
import { student } from '../home/data.js'
import LazyImage from '../LazyImage.jsx';

function StudentWorks() {

    const {student_img_url} = student

    const { work_url_1: ms1,work_url_2: ms2, work_url_3: ms3, work_url_4: ms4, work_url_5: ms5, work_url_6: ms6, work_url_7: ms7, work_url_8: ms8, work_url_9: ms9, work_url_10: ms10 } = ms_works;
    const msImgurl = [ms1, ms2, ms3, ms4, ms5, ms6, ms7, ms8, ms9, ms10];

    const { work_url_1: dtp1, work_url_2:dtp2, work_url_3: dtp3, work_url_4: dtp4, work_url_5: dtp5, work_url_6: dtp6, work_url_7: dtp7, work_url_8: dtp8, work_url_9: dtp9, work_url_10: dtp10 } = dtp_works;
    const dtpImgurl = [dtp1, dtp2, dtp3, dtp4, dtp5, dtp6, dtp7, dtp8, dtp9, dtp10];

    const { work_url_1: c1, work_url_2: c2, work_url_3: c3, work_url_4: c4, work_url_5: c5, work_url_6: c6, work_url_7: c7, work_url_8: c8, work_url_9: c9, work_url_10: c10 } = c_works;
    const clangImgurl = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10];

    const { work_url_1: v1, work_url_2: v2, work_url_3: v3, work_url_4: v4, work_url_5: v5, work_url_6: v6, work_url_7: v7, work_url_8: v8, work_url_9: v9, work_url_10: v10 } = ve_works;
    const veditImgurl = [v1, v2, v3, v4, v5, v6, v7, v8, v9, v10];

    const { work_url_1: t1, work_url_2: t2, work_url_3: t3, work_url_4: t4, work_url_5: t5, work_url_6: t6, work_url_7: t7, work_url_8: t8, work_url_9: t9, work_url_10: t10 } = tally_works;
    const tallyImgurl = [t1, t2, t3, t4, t5, t6, t7, t8, t9, t10];

    const { work_url_1: h1, work_url_2: h2, work_url_3: h3, work_url_4: h4, work_url_5: h5, work_url_6: h6, work_url_7: h7, work_url_8: h8, work_url_9: h9, work_url_10: h10 } = html_works;
    const htmlImgurl = [h1, h2, h3, h4, h5, h6, h7, h8, h9, h10];
  return (
    // <div>
    //     <div>
    //         <h1>StudentWorks</h1>
    //     </div>
    //     <div className='scroll-column'>
            
    //         <div className='marquee-left'>
    //             <h3>MS OFFICE</h3>
    //             <div className="inner-left">
    //         <div className="scroll-content-left">
    //             {[...Array(2)].map((_,i) =>(
    //             <>
    //                 <img key={`ms1-${i}`} src={ms1} alt='img1'></img>
    //                 <img key={`ms2-${i}`} src={ms2} alt='img2'></img>
    //                 <img key={`ms3-${i}`} src={ms3} alt='img3'></img>
    //                 <img key={`ms4-${i}`} src={ms4} alt='img4'></img>
    //             </>
    //             ))}
    //         </div>
    //         </div>
    //         </div>

    //         <div className='marquee-right'>
    //             <h3>DTP</h3>
    //             <div className="inner-right">
    //         <div className="scroll-content-right">
    //             {[...Array(2)].map((_,i) =>(
    //             <>
    //                 <img key={`dtp1-${i}`} src={dtp1} alt='img1'></img>
    //                 <img key={`dtp2-${i}`} src={dtp2} alt='img2'></img>
    //                 <img key={`dtp3-${i}`} src={dtp3} alt='img3'></img>
    //                 <img key={`dtp4-${i}`} src={dtp4} alt='img4'></img>
    //             </>
    //             ))}
    //         </div>
    //         </div>
    //         </div>

    // </div>
    <div>
      <Header/>
        <Menubar/>

          <div className='student-img'>
            <LazyImage src={student_img_url} style={{width: '100%'}} alt="Student-Works" />
          </div>
        	<section className='student-w'>
                <div className="">
                    <h1 style={{borderBottomStyle: 'groove'}}>STUDENTS WORKS</h1>
                </div>
            </section>

     <div className="scroll-column">
        <MarqueeSection title="MS Office" images={msImgurl} direction="left" />
        <MarqueeSection title="DTP" images={dtpImgurl} direction="right" />
        <MarqueeSection title="C-LANGUAGE" images={clangImgurl} direction="left" />
        <MarqueeSection title="VIDEO EDITING" images={veditImgurl} direction="right" />
        <MarqueeSection title="TALLY" images={tallyImgurl} direction="left" />
        <MarqueeSection title="HTML" images={htmlImgurl} direction="right" />
      </div>
      <Address/>
      <ScrollToTopProgress/>
      </div>
  )
}

export default StudentWorks